import React, { useEffect, useState } from "react";
import { createSlice } from "@reduxjs/toolkit";
import { addEvent } from "../constants/config";

const loggedUserData = JSON.parse(localStorage.getItem("user")) || {};
const userType = loggedUserData?.data?.empresas?.[0]?.tipo || "";
const { id_usuario = "", nrocli = "" } = loggedUserData?.data?.cliente || {};
const { ip = "", dispositivo = "", tipo_dispositivo = "" } = loggedUserData?.data || {};


const initialState = {
  userInfo: [],
  products: [],
};

const getQuantityWithinStock = (product, quantity) => {
  const requestedQuantity = Math.max(0, Number(quantity) || 0);
  const stock = Number(product?.Stock);

  return Number.isFinite(stock)
    ? Math.min(requestedQuantity, Math.max(0, stock))
    : requestedQuantity;
};

export const orebiSlice = createSlice({
  name: "orebi",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const item = state.products.find(
        (item) => item.codigo === action.payload.codigo
      );
      const quantity = getQuantityWithinStock(item || action.payload, action.payload.quantity);

      if (quantity <= 0) return;
      if (item) {
        // Cambiar aquí: en lugar de sumar, simplemente asignar la cantidad
        item.quantity = quantity;
        addEvent(id_usuario, nrocli, ip, dispositivo, tipo_dispositivo, 4, '', item.codigo, 1);
      } else {
        // Al agregar un nuevo producto, establecer la cantidad
        state.products.push({ ...action.payload, quantity });
        // console.log(action.payload)
        addEvent(id_usuario, nrocli, ip, dispositivo, tipo_dispositivo, 4, '', action.payload.codigo, 1);
      }

    },
    increaseQuantity: (state, action) => {
      const item = state.products.find(
        (item) => item.codigo === action.payload.codigo
      );

      if (item) {
        const nextQuantity = getQuantityWithinStock(item, Number(item.quantity) + 1);
        if (nextQuantity > item.quantity) {
          item.quantity = nextQuantity;
          addEvent(id_usuario, nrocli, ip, dispositivo, tipo_dispositivo, 5, '', item.codigo, 1);
        }
      }
    },

    drecreaseQuantity: (state, action) => {
      const item = state.products.find(
        (item) => item.codigo === action.payload.codigo
      );

      if (item) {
        if (item.quantity === 1) {
          item.quantity = 1;
        } else {
          item.quantity--;
          addEvent(id_usuario, nrocli, ip, dispositivo, tipo_dispositivo, 6, '', item.codigo, -1);
        }
      }
    },

    deleteItem: (state, action) => {
      const producto = state.products.find(
        (item) => item.codigo === action.payload
      );

      if (producto) {
        const codigo = producto.codigo;
        const cantidad = -producto.quantity;

        addEvent(id_usuario, nrocli, ip, dispositivo, tipo_dispositivo, 10, '', codigo, cantidad);
      }

      state.products = state.products.filter(
        (item) => item.codigo !== action.payload
      );
    },

    resetCart: (state, action) => {
      const event = action?.payload?.event ?? 0; // Por defecto 0 si no viene

      const productos = [...state.products];

      if (event !== 1) {
        for (let i = 0; i < productos.length; i++) {
          const codigo = productos[i].codigo;
          const cantidad = -productos[i].quantity;

          addEvent(
            id_usuario,
            nrocli,
            ip,
            dispositivo,
            tipo_dispositivo,
            11,
            '',
            codigo,
            cantidad
          );
        }
      }

      state.products = [];
    },


  },
});

export const {
  addToCart,
  increaseQuantity,
  drecreaseQuantity,
  deleteItem,
  resetCart,
} = orebiSlice.actions;
export default orebiSlice.reducer;
